import { withStyles } from '@material-ui/core';
import styles from './ProductPrice.styles';
import ProductPrice from './ProductPrice';

export default withStyles(styles)(ProductPrice);
